module.exports = __webpack_public_path__ + "img/icon-news-1.0c84f119.png";